import {yupResolver} from '@hookform/resolvers/yup'
import {Dispatch, FC, SetStateAction, useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useForm, FormProvider} from 'react-hook-form'
import * as Yup from 'yup'
import {KTSVG} from '../../../../../../../../_metronic/helpers'
import {Select} from '../../../../../../components/UI/Select'
import {AttendClaimUserDocument, AttendClaimUserModel} from '../../../../model/claimUser.model'
import {useCentral} from '../../../../../../hooks/useCentral'
import {InputDate, InputText, InputTextArea} from '../../../../../../components/UI/Input'
import {UserModel} from '../../../../model'
import {getMasterService, getUser} from '../../../../services'
import moment from 'moment'
import {SelectModel} from '../../../../../lavanderia/model'
import {getClaimById} from '../../../../services/claimUser.service'
import {formatDate} from '../../../../../../util/dates'

interface Props {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
  claimToEdit: AttendClaimUserDocument
  getAttentionList: () => void
  created: boolean
}

const ModalAttendClaim: FC<Props> = ({show, setShow, claimToEdit, created}) => {
  const handleClose = () => {
    setShow(false)
    resetForm()
  }
  const {currentTabItem} = useCentral()
  const [users, setUsers] = useState<any[]>([])
  const [requerimentTypes, setRequerimentTypes] = useState<SelectModel[]>([])

  const attendSchema = Yup.object().shape({
    ResponsableId: Yup.string().required('Responsable es requerido'),
    FechaAtencion: Yup.string().required('Fecha de Atencion es requerido'),
    Atencion: Yup.string().required('Atencion es requerido'),
  })

  const methods = useForm<AttendClaimUserModel>({
    resolver: yupResolver(attendSchema),
  })

  const {
    register,
    setValue,
    setError,
    control,
    formState: {errors},
  } = methods
  const getUsers = async (filters: UserModel, page: number) => {
    try {
      const response = await getUser(filters, 1)
      const data = response.data.data
      const mappedUsers = data?.map((user) => ({
        value: user.id,
        label: `${user.nombres || ''} ${user.apellidos || ''} ${user.numeroDocumento || ''}`,
        ...user,
      }))
      setUsers(mappedUsers)
    } catch (error) {
      return []
    }
  }

  const getRequerimentTypes = async () => {
    try {
      const response = await getMasterService({
        pageNumber: 1,
        size: 100,
        tableName: 'TipoRequerimiento',
      })
      const data = response.data.data
      const mappedMaster = data.map((master) => ({
        value: master.id,
        label: master.nombreCorto,
      }))
      setRequerimentTypes(mappedMaster)
    } catch (error) {
      console.error('Error al obtener la lista de tipo de requerimientos:', error)
    }
  }

  const getClaimId = async () => {
    try {
      const {idToEdit} = currentTabItem
      if (idToEdit) {
        const {
          data: {data},
        } = await getClaimById(idToEdit as any)
        const {tipoRequerimientoId} = data
        setValue('TipoRequerimientoId', tipoRequerimientoId)
      }
    } catch (error) {}
  }

  const handleSetUserInfo = async (val: any) => {
    let value = val ? val.value : ''
    setValue('ResponsableId', value)
    setError('ResponsableId', {})
    setValue('Cargo_Responsable', val.cargo)
    setValue('Empresa_Responsable', val.empresa)
    setValue('Telefono_Responsable', val.telefono)
    setValue('Email_Responsable', val.email)
  }

  const resetForm = () => {
    setValue('ResponsableId', '')
    setValue('Cargo_Responsable', '')
    setValue('Empresa_Responsable', '')
    setValue('Telefono_Responsable', '')
    setValue('Email_Responsable', '')
    setValue('FechaAtencion', '')
    setValue('Atencion', '')
  }

  useEffect(() => {
    getUsers({isCombo: true}, 1)
    setValue('RequerimientoId', currentTabItem.idToEdit as any)
    // setValue('ReservaId', currentTabItem.idToEdit as any)
  }, [])

  useEffect(() => {
    if (!created) {
      setValue('Id', claimToEdit?.Id)
      setValue('ResponsableId', claimToEdit?.ResponsableId)
      setValue('Cargo_Responsable', claimToEdit?.Responsable_cargo)
      setValue('Empresa_Responsable', claimToEdit?.Responsable_empresa)
      setValue('Telefono_Responsable', claimToEdit?.Responsable_telefono)
      setValue('Email_Responsable', claimToEdit?.Responsable_email)
      setValue('FechaAtencion', formatDate(claimToEdit?.FechaAtencion))
      setValue('Atencion', claimToEdit?.Atencion)
    }
  }, [created])

  useEffect(() => {
    getUsers({isCombo: true}, 1)
    getRequerimentTypes()
    getClaimId()
    setValue('RequerimientoId', currentTabItem.idToEdit as any)
  }, [])

  return (
    <Modal
      className='modal fade'
      show={show}
      dialogClassName='modal-xl'
      aria-hidden='true'
      onHide={handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h5 className='modal-title'>Ver Respuesta</h5>

          <div className='btn btn-icon btn-sm btn-active-light-primary ms-2' onClick={handleClose}>
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          <FormProvider {...methods}>
            <form>
              <div className='p-6'>
                <div className='row'>
                  <div className='col-sm-12 col-lg-3'>
                    <label className=''>Tipo de Requerimiento:</label>
                    <Select
                      control={control}
                      name='TipoRequerimientoId'
                      data={requerimentTypes}
                      errors={errors}
                      disabled
                    />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <label className='required'>Datos del responsable que atiende</label>
                    <Select
                      control={control}
                      name='ResponsableId'
                      data={users}
                      errors={errors}
                      onChangeValue={handleSetUserInfo}
                      disabled
                    />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <label className=''>Cargo del responsable de atencion:</label>
                    <InputText
                      register={register}
                      name='Cargo_Responsable'
                      errors={errors}
                      disabled
                    />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <label className=''>Empresa del responsable de atencion:</label>
                    <InputText
                      register={register}
                      name='Empresa_Responsable'
                      errors={errors}
                      disabled
                    />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <label className=''>Telefono del responsable de atencion:</label>
                    <InputText
                      register={register}
                      name='Telefono_Responsable'
                      errors={errors}
                      disabled
                    />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <label className=''>Email del responable de atencion:</label>
                    <InputText
                      register={register}
                      name='Email_Responsable'
                      errors={errors}
                      disabled
                    />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <label className='required'>Fecha de atencion:</label>
                    <InputDate
                      name='FechaAtencion'
                      register={register}
                      errors={errors}
                      minValue='1900-01-01'
                      defaultValue={moment().format('YYYY-MM-DD')}
                      disabled
                    />
                  </div>
                  <div className='col-sm-12 col-lg-9'>
                    <label className='required'>Respuesta y/o comentario de atencion:</label>
                    <InputTextArea register={register} name='Atencion' errors={errors} disabled />
                  </div>
                </div>
                {/* <pre>{JSON.stringify(watch(), null, 2)}</pre> */}
              </div>

              <div className='d-flex justify-content-center mb-3'>
                <button type='button' className='btn btn-light-primary me-5' onClick={handleClose}>
                  Cancelar
                </button>
              </div>
            </form>
          </FormProvider>
        </div>
      </div>
    </Modal>
  )
}

export {ModalAttendClaim}
